import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { Images } from "../../../../assets/assets";
import "./ServiceArea.css";
import { useHomeStore } from "../../../../store/useHomeStore";




const ServiceArea = () => {
    const { serviceArea } = useHomeStore()
    return (
        <section  id="service-area" className="service-area-section">
            <Container className="theme-container">
                <div className="section-header">
                    <p className="section-subtitle">{serviceArea?.subTitle}</p>
                    <h3>{serviceArea?.title}</h3>
                    <p className="description text-light-gray fs-6 mt-xl-4 mt-2 mb-xl-5 mb-lg-4 mb-3">
                        {serviceArea?.description}
                    </p>
                </div>

                <Row className="g-4 market-served-content-row">
                    <Col sm={12}>
                        {/* <img className="img-fluid" src={Images.MapImg} alt="map image" /> */}
                        <img className="img-fluid" src={serviceArea?.image} alt="map image" />
                    </Col>
                </Row>
            </Container>
        </section>
    )
};

export default ServiceArea;
